import request from './request'

export function doctorList(data) {
    return request({
        url: '/api/saleman/doctorList',
        method: 'get',
        params: data
    })
}

export function getGroupSalesman(data) {
    return request({
        url: '/api/saleman/getGroupSalesman',
        method: 'get',
        params: data
    })
}

export function memberInfo(data) {
    return request({
        url: '/api/member/info',
        method: 'get',
        params: data
    })
}

export function biangengSalesman(data) {
    return request({
        url: '/api/member/biangengSalesman',
        method: 'post',
        data: data
    })
}

export function visitLog(data) {
    return request({
        url: '/api/saleman/visitLog',
        method: 'get',
        params: data
    })
}

export function saveVisitLog(data) {
    return request({
        url: '/api/saleman/saveVisitLog',
        method: 'post',
        data: data
    })
}